package or.garden.manager.domain.model

import kotlinx.serialization.Serializable

@Serializable
enum class FertilizerType {
    FERMENTATION,
    TEA,
    CHEMICAL_REACTION
}

@Serializable
enum class FertilizerStatus {
    PREPARING,
    READY,
    EXPIRED,
    ARCHIVED
}

@Serializable
enum class ApplicationMethod {
    FOLIAR,
    ROOT,
    BOTH
}

@Serializable
data class NaturalFertilizer(
    val id: Int? = null,
    val name: String,
    val type: FertilizerType,
    val status: FertilizerStatus,
    val createdAt: Long,
    val readyAt: Long? = null,
    val expiresAt: Long? = null,
    val ingredients: String? = null,
    val applicationMethod: ApplicationMethod,
    val dilutionRatio: String? = null,
    val notes: String? = null,
    val isOrganic: Boolean = true,
    val userId: Int? = null,
    val isAdminCreated: Boolean = false
)

@Serializable
data class CreateNaturalFertilizerRequest(
    val name: String,
    val type: FertilizerType,
    val ingredients: String? = null,
    val applicationMethod: ApplicationMethod,
    val dilutionRatio: String? = null,
    val notes: String? = null,
    val isOrganic: Boolean = true,
    val createdAt: Long? = null
)

@Serializable
data class AiFertilizerRequest(
    val prompt: String
)

@Serializable
data class AiFertilizerResponse(
    val name: String,
    val type: FertilizerType,
    val applicationMethod: ApplicationMethod,
    val ingredients: String,
    val dilutionRatio: String,
    val notes: String,
    val isOrganic: Boolean = true
)

@Serializable
data class UpdateNaturalFertilizerRequest(
    val name: String? = null,
    val type: FertilizerType? = null,
    val status: FertilizerStatus? = null,
    val ingredients: String? = null,
    val applicationMethod: ApplicationMethod? = null,
    val dilutionRatio: String? = null,
    val notes: String? = null,
    val isOrganic: Boolean? = null,
    val readyAt: Long? = null,
    val expiresAt: Long? = null
)
